import { useCallback, useRef } from 'preact/hooks';

import { useFocusWithin } from '../hooks/UNSAFE_useFocusWithin';

export function usePopupFocusWithin() {
  const ref = useRef<HTMLElement | null>(null);
  const { focusProps, isFocused } = useFocusWithin();

  const onTransitionEnd = useCallback(
    (isAfterOpen?: boolean) => {
      if (isAfterOpen) {
        if (focusProps.onfocusin) {
          ref.current?.addEventListener('focusin', focusProps.onfocusin, false);
        }
        if (focusProps.onfocusout) {
          ref.current?.addEventListener('focusout', focusProps.onfocusout, false);
        }
      } else {
        if (focusProps.onfocusin) {
          ref.current?.removeEventListener('focusin', focusProps.onfocusin, false);
        }
        if (focusProps.onfocusout) {
          ref.current?.removeEventListener('focusout', focusProps.onfocusout, false);
        }
      }
    },
    [focusProps.onfocusin, focusProps.onfocusout, ref]
  );

  return {
    isFocused,
    popupProps: {
      onTransitionEnd,
      ref
    }
  };
}
